// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const commentsHistoryConfig = {
    title: 'chart.tiktok.comments_history',
    tooltip: 'chart.tiktok.tooltip_comments_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.tiktok.comments_history_name',
        avg: 'chart.tiktok.comments_history_avg'
    },
    id: 'comments_history',
    color: {
        value: 'yellow',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.tiktok.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
